/**
 * templateService.js
 *
 * WhatsApp template-related API calls (local backend, not Meta Graph API).
 *
 * Usage:
 *   import { templateService } from 'services/api';
 */

import apiClient from '../apiClient';

export const templateService = {
  /** GET templates from backend cache/proxy */
  getTemplates: (wabaId, waToken) => {
    // Templates from Meta Graph API are fetched via context (waToken is different)
    // This is for local backend operations
    return apiClient.get(`/templates/${wabaId}`).then((res) => res.data);
  },

  /** GET messaging templates */
  getMessagingTemplates: () => {
    return apiClient.get("messaging/templates").then((res) => res.data);
  },

  /** POST /campaigns — create a campaign */
  createCampaign: (data) =>
    apiClient.post('/campaigns', data).then((res) => res.data),

  /** GET /campaigns/:userId — list campaigns */
  getCampaigns: (userId) =>
    apiClient.get(`/campaigns/${userId}`).then((res) => res.data),

  /** DELETE /campaigns/:id */
  deleteCampaign: (id) =>
    apiClient.delete(`/campaigns/${id}`).then((res) => res.data),
};
